/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCompanyRoleSettings200ResponsePermissionsInner } from './GetCompanyRoleSettings200ResponsePermissionsInner';
import {
    GetCompanyRoleSettings200ResponsePermissionsInnerFromJSON,
    GetCompanyRoleSettings200ResponsePermissionsInnerFromJSONTyped,
    GetCompanyRoleSettings200ResponsePermissionsInnerToJSON,
} from './GetCompanyRoleSettings200ResponsePermissionsInner';

/**
 * 
 * @export
 * @interface GetCompanyRoleSettings200Response
 */
export interface GetCompanyRoleSettings200Response {
    /**
     * ステータス
     * @type {number}
     * @memberof GetCompanyRoleSettings200Response
     */
    status: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof GetCompanyRoleSettings200Response
     */
    message: string;
    /**
     * `権限コード`
     * @type {string}
     * @memberof GetCompanyRoleSettings200Response
     */
    roleCode: string;
    /**
     * `権限名`
     * @type {string}
     * @memberof GetCompanyRoleSettings200Response
     */
    roleName: string;
    /**
     * `管理者ステータス true:管理者 false:一般`
     * @type {boolean}
     * @memberof GetCompanyRoleSettings200Response
     */
    isAdministrator: boolean;
    /**
     * `許可設定`
     * @type {Array<GetCompanyRoleSettings200ResponsePermissionsInner>}
     * @memberof GetCompanyRoleSettings200Response
     */
    permissions?: Array<GetCompanyRoleSettings200ResponsePermissionsInner>;
}

/**
 * Check if a given object implements the GetCompanyRoleSettings200Response interface.
 */
export function instanceOfGetCompanyRoleSettings200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "roleCode" in value;
    isInstance = isInstance && "roleName" in value;
    isInstance = isInstance && "isAdministrator" in value;

    return isInstance;
}

export function GetCompanyRoleSettings200ResponseFromJSON(json: any): GetCompanyRoleSettings200Response {
    return GetCompanyRoleSettings200ResponseFromJSONTyped(json, false);
}

export function GetCompanyRoleSettings200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompanyRoleSettings200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'roleCode': json['role_code'],
        'roleName': json['role_name'],
        'isAdministrator': json['is_administrator'],
        'permissions': !exists(json, 'permissions') ? undefined : ((json['permissions'] as Array<any>).map(GetCompanyRoleSettings200ResponsePermissionsInnerFromJSON)),
    };
}

export function GetCompanyRoleSettings200ResponseToJSON(value?: GetCompanyRoleSettings200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'role_code': value.roleCode,
        'role_name': value.roleName,
        'is_administrator': value.isAdministrator,
        'permissions': value.permissions === undefined ? undefined : ((value.permissions as Array<any>).map(GetCompanyRoleSettings200ResponsePermissionsInnerToJSON)),
    };
}

